// ATS-optimized CV content (plain language, full dates, expanded acronyms, extra keywords)
export const atsCvTranslations = {
  en: {
    title: "Data Scientist · AI/ML Automation & Test Engineer",
    summary: "Professional Summary",
    summaryText:
      "Data Scientist, 4+ years in ML models: predictive analytics (Python, Scikit-learn) to generative AI (LangChain/LangGraph, OpenAI, Claude, Gemini). MLOps (MLflow, Dataiku), AI/ML evaluation, large-scale pipelines. 20+ models (85%+), 100K+ data points, production AI validation.",
    experience: "Professional Experience",
    education: "Education",
    skills: "Technical Skills",
    projects: "Professional Projects",
    languages: "Languages",
    downloadPDF: "Download PDF",
    portfolio: "Portfolio",
    styledCV: "Styled CV",
    experiences: [
      {
        title: "AI/ML Automation & Test Engineer",
        company: "Applause",
        location: "Remote",
        period: "May 2026 – Present",
        points: [
          "Validate AI/ML outputs across end-to-end test cycles",
          "Monday.com automation: data filtering, board config and workflow",
          "Coordinate test teams (TTLs/DTs), escalation across concurrent cycles",
        ],
      },
      {
        title: "Automation & Full-Stack Engineer / Data Analysis",
        company: "Edpulse",
        location: "Quebec (Remote)",
        period: "November 2024 – May 2026",
        points: [
          "LangChain/LangGraph chatbots (OpenAI, Claude, Gemini) in microservices",
          "Full-stack subscription React/Node.js with Stripe, SSO and CI/CD",
          "Automation (-60%), KPI dashboards, ETL 10+ sources, Railway monitoring",
        ],
      },
      {
        title: "Data Scientist",
        company: "Arhs Development",
        location: "Brussels, Belgium",
        period: "June 2023 – June 2024",
        points: [
          "Python/Scikit-learn ML models for finance and legal (85%+)",
          "Train 15+ teams on Dataiku; MLOps MLflow, 20+ models in production",
        ],
      },
      {
        title: "Data Scientist Intern",
        company: "Sanofi",
        location: "Gentilly, Ile-de-France",
        period: "April 2022 – November 2022",
        points: [
          "ML models for pharma market (Oncology/Dupixent), 100K+ data points",
          "Python/SQL ETL (-50% reporting); Power BI dashboards (30+ analysts)",
        ],
      },
      {
        title: "Freelance Data Scientist",
        company: "Khamsat",
        location: "Freelance",
        period: "April 2020 – June 2020",
        points: [
          "Python scraping (10K+ products/day) and Django ML app with medical prediction",
        ],
      },
    ],
    education_items: [
      {
        degree: "Master ML for Data Science (MLSD)",
        school: "Université Paris-Cité",
        location: "Paris, France",
        year: "2022",
        project: "",
      },
      {
        degree: "Master Big Data & Cloud Computing",
        school: "Université Ibn Tofail",
        location: "Kénitra, Morocco",
        year: "2021",
        project: "",
      },
      {
        degree: "Bachelor Mathematics & Computer Science",
        school: "Université Ibn Tofail",
        location: "Kénitra, Morocco",
        year: "2019",
        project: "",
      },
    ],
    skills_list: [
      "Python, JavaScript, R, SQL, Java, C, C++, Shell | LangChain, LangGraph, OpenAI API, Claude API, TensorFlow, PyTorch, Scikit-learn, NLP",
      "React, Node.js, Django, Laravel, REST APIs, Stripe, SSO | Azure, Docker, MLOps, MLflow, Spark, Pandas, NumPy, Power BI, Dataiku",
      "PostgreSQL, Supabase, MongoDB, SQL Server, Oracle | Git, GitHub, CI/CD, Agile, Scrum, ETL, Postman, Selenium, Jupyter, VS Code, Monday.com, Railway",
    ],
    projects_items: [
      {
        title: "AI Chatbot & SaaS Platform",
        description:
          "LangChain/LangGraph chatbot (OpenAI, Claude, Gemini) and full-stack SaaS (Stripe, SSO, analytics)",
      },
      {
        title: "Professional Websites",
        description:
          "Event-equipment rental (booking & payment) and dental clinic site (appointments)",
      },
    ],
    languages_items: [
      { lang: "French", level: "Fluent" },
      { lang: "English", level: "Fluent" },
      { lang: "Arabic", level: "Native" },
    ],
  },
  fr: {
    title: "Data Scientist · Ingénieur Automatisation & Test IA/ML",
    summary: "Résumé Professionnel",
    summaryText:
      "Data Scientist, 4+ ans en modèles ML : analyse prédictive (Python, Scikit-learn) à IA générative (LangChain/LangGraph, OpenAI, Claude, Gemini). MLOps (MLflow, Dataiku), évaluation IA/ML, pipelines à grande échelle. 20+ modèles (85%+), 100K+ points, validation IA en production.",
    experience: "Expérience Professionnelle",
    education: "Formation",
    skills: "Compétences Techniques",
    projects: "Projets Professionnels",
    languages: "Langues",
    downloadPDF: "Télécharger PDF",
    portfolio: "Portfolio",
    styledCV: "CV Design",
    experiences: [
      {
        title: "Ingénieur Automatisation & Test IA/ML",
        company: "Applause",
        location: "Télétravail",
        period: "Mai 2026 – Présent",
        points: [
          "Validation sorties IA/ML sur cycles de test end-to-end",
          "Automatisation Monday.com : filtrage de données, tableaux et workflow",
          "Coordination équipes test (TTLs/DTs), escalade sur cycles simultanés",
        ],
      },
      {
        title: "Ingénieur Automatisation & Full-Stack / Analyse de Données",
        company: "Edpulse",
        location: "Québec (Télétravail)",
        period: "Novembre 2024 – Mai 2026",
        points: [
          "Chatbots LangChain/LangGraph (OpenAI, Claude, Gemini) en microservices",
          "Abonnement full-stack React/Node.js avec Stripe, SSO et CI/CD",
          "Automatisation (-60%), dashboards KPI, ETL 10+ sources, monitoring Railway",
        ],
      },
      {
        title: "Data Scientist",
        company: "Arhs Development",
        location: "Bruxelles, Belgique",
        period: "Juin 2023 – Juin 2024",
        points: [
          "Modèles ML Python/Scikit-learn pour finance et juridique (85%+)",
          "Formation 15+ équipes Dataiku ; MLOps MLflow, 20+ modèles en production",
        ],
      },
      {
        title: "Data Scientist Stagiaire",
        company: "Sanofi",
        location: "Gentilly, Île-de-France",
        period: "Avril 2022 – Novembre 2022",
        points: [
          "Modèles ML marché pharma (Oncologie/Dupixent), 100K+ points",
          "ETL Python/SQL (-50% reporting) ; dashboards Power BI (30+ analystes)",
        ],
      },
      {
        title: "Data Scientist Freelance",
        company: "Khamsat",
        location: "Freelance",
        period: "Avril 2020 – Juin 2020",
        points: [
          "Scraping Python (10K+ produits/jour) et app Django ML avec prédiction médicale",
        ],
      },
    ],
    education_items: [
      {
        degree: "Master ML pour la Science des Données (MLSD)",
        school: "Université Paris-Cité",
        location: "Paris, France",
        year: "2022",
        project: "",
      },
      {
        degree: "Master Big Data & Cloud Computing",
        school: "Université Ibn Tofail",
        location: "Kénitra, Maroc",
        year: "2021",
        project: "",
      },
      {
        degree: "Licence Mathématiques & Informatique",
        school: "Université Ibn Tofail",
        location: "Kénitra, Maroc",
        year: "2019",
        project: "",
      },
    ],
    skills_list: [
      "Python, JavaScript, R, SQL, Java, C, C++, Shell | LangChain, LangGraph, OpenAI API, Claude API, TensorFlow, PyTorch, Scikit-learn, NLP",
      "React, Node.js, Django, Laravel, REST APIs, Stripe, SSO | Azure, Docker, MLOps, MLflow, Spark, Pandas, NumPy, Power BI, Dataiku",
      "PostgreSQL, Supabase, MongoDB, SQL Server, Oracle | Git, GitHub, CI/CD, Agile, Scrum, ETL, Postman, Selenium, Jupyter, VS Code, Monday.com, Railway",
    ],
    projects_items: [
      {
        title: "Chatbot IA & Plateforme SaaS",
        description:
          "Chatbot LangChain/LangGraph (OpenAI, Claude, Gemini) et SaaS full-stack (Stripe, SSO, analytics)",
      },
      {
        title: "Sites Web Professionnels",
        description:
          "Location matériel événementiel (réservation & paiement) et site cabinet dentaire (rendez-vous)",
      },
    ],
    languages_items: [
      { lang: "Français", level: "Courant" },
      { lang: "Anglais", level: "Courant" },
      { lang: "Arabe", level: "Langue maternelle" },
    ],
  },
};
